import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormCategoryService, FormService, FormTemplateService } from '@nrwl/rx-service-forms';

import { RxComposite } from '../model/rx-composite';
import { Store } from '@ngrx/store';
import { environment } from '@nrwl/environment';
import { RxAccordionModule } from '@nrwl/rx-accordion';
import { MatListModule } from '@angular/material/list';
import { RxIconModule } from '@nrwl/rx-icon';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rx-forms-browser',
  templateUrl: './rx-forms-browser.component.html',
  styleUrls: ['./rx-forms-browser.component.scss'],
  imports: [CommonModule, FormsModule, RxAccordionModule, MatListModule, RxIconModule],
})
export class RxFormsBrowserComponent extends RxComposite implements OnInit {
  selectTemplate: any;
  template: any;
  index: number;
  selected: any;
  env = environment;

  public formCategories: any = [];
  public formTemplates: any = [];

  constructor(
    private store: Store<any>,
    private formService: FormService,
    private formCategoryService: FormCategoryService,
    private formTemplateService: FormTemplateService,
  ) {
    super();
  }

  ngOnInit() {
    this.payload.tid = null;
    this.formCategoryService.getFormCategories().subscribe((formCategories) => {
      this.formCategories = formCategories;
    });
    this.formTemplateService.getAllFormTemplates().subscribe((formTemplates) => {
      this.formTemplates = formTemplates;
    });
  }

  filterByCategory(id: any) {
    return this.formTemplates.filter((res: any) => res.category === id);
  }

  selectedItem(id) {
    this.selected = id;
    this.payload.tid = id;
  }

  checkTemplate() {
    this.formService.getForm().subscribe();
  }
}
